import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxMainStyled = styled(Box)({
  paddingTop: '16px',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  width: '100%',
  gap: '10px 24px',
});

export const BoxAdditionalStyled = styled(Box)({
  paddingTop: '16px',
  display: 'flex',
  width: '100%',
  gap: '24px',
});
